if (!customElements.get('product-card-price')) {
  customElements.define(
    'product-card-price',
    class ProductCardPrice extends HTMLElement {
      constructor() {
        super();
        this.boundInit = this.initialize.bind(this);
        this.fromPrice = this.dataset.fromPrice;
        this.activeCurrency = window?.Shopify?.currency;
      }

      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.boundInit, { once: true });
          return;
        }
        this.initialize();
      }

      initialize() {
        this.calculatePrice();
      }

      calculatePrice() {
        if (!this.fromPrice || !this.activeCurrency) return;
        let fromPrice =
          Number(this.fromPrice) * Number(window.exchangeTable[this.activeCurrency.active] ?? 1);
        if (this.dataset.disc) {
          fromPrice = fromPrice * Number(this.dataset.disc);
        }
        this.innerHTML = `${this.dataset.s ? '' : 'From '}${this.dataset.disc ? `${this.activeCurrency.active.slice(0, 2)}` : ''}${this.formatPrice(this.activeCurrency.active, fromPrice)}/day`;
      }

      formatPrice(currency, val) {
        const formattedPrice = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol',
        });
        return formattedPrice.format(val).replace(/\.00$/, '');
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.boundInit);
      }
    },
  );
}
